import {
  HOUSE_KEEPING_ROOM_STATE_REPORT_GET_ALL,
  HOUSE_KEEPING_ROOM_STATE_REPORT_UPDATE,
} from '@constants/ApiEndpoints/HouseKeepingRootEndpoint';
import { AxiosInstance } from 'axios';
import { FilterMenuModel } from 'pages/HouseKeepingModule/pages/HouseKeepingReportPage/models/FilterMenuModel';
import {
  HouseKeepingRoomStateFormModel,
  RoomStatusListModel,
} from 'pages/HouseKeepingModule/pages/HouseKeepingReportPage/models/RoomStatusModel';

export type Params = {
  search?: string;
  limit?: number;
  offset?: number;
};

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: {
      room_number?: string | undefined;
      limit?: number;
      offset?: number;
    } & Partial<FilterMenuModel>
  ): Promise<RoomStatusListModel> =>
    await axios.get(HOUSE_KEEPING_ROOM_STATE_REPORT_GET_ALL, { params }).then(({ data }) => data);

export const update =
  (axios: AxiosInstance) =>
  async (
    data: Partial<HouseKeepingRoomStateFormModel>
  ): Promise<{
    data: any;
    status: number;
    non_traited_period: {
      from: string;
      to: string;
      maintenance_type_id: number;
      comment: string;
      room_id: number;
    }[];
  }> => {
    return await axios
      .post(HOUSE_KEEPING_ROOM_STATE_REPORT_GET_ALL, data)
      .then(({ data }) => data?.items);
  };

export const reportIssue =
  (axios: AxiosInstance) =>
  async (data: {
    room_id: number;
    adults: number;
    children: number;
    inf: number;
    comment: string;
  }): Promise<{
    data: any;
    status: number;
  }> => {
    return await axios.post(HOUSE_KEEPING_ROOM_STATE_REPORT_UPDATE, data).then(({ data }) => data);
  };
